import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { CopyIDMenuItem } from '#components/patterns/menus/meatball-menu/CopyIDMenuItem.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteJoinKeyDialog } from '../delete/DeleteJoinKeyDialog.tsx';

type Props = {
  value: string;
};

export function JoinKeysActionMenu({ value: id }: Props) {
  const [isDeleting, setIsDeleting] = useState(false);
  const location = useAppLocation();

  return (
    <>
      <MeatballMenu>
        <CopyIDMenuItem id={id} />
        <MenuItem render={<Link to={id} state={{ from: location }} />}>Edit</MenuItem>
        <MenuItem onClick={() => setIsDeleting(true)}>Revoke</MenuItem>
      </MeatballMenu>
      {isDeleting ?
        <DeleteJoinKeyDialog
          joinKeyID={id}
          onDelete={() => setIsDeleting(false)}
          onCancel={() => setIsDeleting(false)}
        />
      : null}
    </>
  );
}
